"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _clearCredentials = _interopRequireDefault(require("./clearCredentials"));
var _getCookie = _interopRequireDefault(require("./getCookie"));
var _constants = _interopRequireDefault(require("./constants"));
var _auth = _interopRequireDefault(require("./auth.utils"));
var _default = exports["default"] = function _default() {
  var signInModeCookieResponse = (0, _getCookie["default"])('signInMode');
  if (!signInModeCookieResponse.cookieExists) {
    _clearCredentials["default"].all();
    return Promise.reject(new Error('Not logged in.'));
  }
  switch (signInModeCookieResponse.cookieValue) {
    case _constants["default"].cognito:
      return _auth["default"].fetchAuthSession().then(function () {
        return 'Signed in with cognito';
      })["catch"](/*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var _t;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _clearCredentials["default"].all();
              _context.prev = 1;
              _context.next = 2;
              return _auth["default"].signOut()["catch"](function () {
                return null;
              });
            case 2:
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](1);
              console.log("Error signing out", _t);
              Promise.reject(new Error('Not able to sign out.'));
            case 4:
              return _context.abrupt("return", Promise.reject(new Error('Not logged in.')));
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 3]]);
      })));
    case _constants["default"].microsoft:
      var microsoftRefreshTokenCookieResponse = (0, _getCookie["default"])('microsoftRefreshToken');
      if (microsoftRefreshTokenCookieResponse.cookieExists) return Promise.resolve('Signed in with microsoft');
      _clearCredentials["default"].all();
      return Promise.reject(new Error('Not logged in.'));
    case _constants["default"].google:
      var googleRefreshTokenCookieResponse = (0, _getCookie["default"])('googleRefreshToken');
      if (googleRefreshTokenCookieResponse.cookieExists) return Promise.resolve('Signed in with google');
      _clearCredentials["default"].all();
      return Promise.reject(new Error('Not logged in.'));
    default:
      _clearCredentials["default"].all();
      return Promise.reject(new Error('Not logged in.'));
  }
};